import { Platform } from 'react-native';

let Quill;
if (Platform.OS === 'web') {
  Quill = require('./WebQuill').default;
} else {
  Quill = require('./MobileQuill').default;
}

export default Quill;